(function(){
  function shouldLoad(){
    var body=document.body;
    var cls=body?body.className:'';
    if(/\btemplate-(product|collection|cart|search|index)\b/.test(cls)) return true;
    if(document.querySelector('[data-timesact], .timesact, .timesact-preorder, [class*="timesact-"]')) return true;
    return false;
  }
  if(!shouldLoad()) return;
  var current=document.currentScript;
  if(!current||!current.src) return;
  var fullUrl=new URL('timesact-full.js',current.src).href;
  var s=document.createElement('script');
  s.src=fullUrl;
  s.async=false;
  document.head.appendChild(s);
})();